import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
export const _VideoType = Fold.compose(Optics._Col2Items, Optics._ColItem2Video, Optics._Video2Attributes, Lens.prop("videoType"), M._Just());
export const _Video = Fold.compose(Optics._Col2Video, Res._Response(), Fold.mapF((x) => ({
    id: x.id,
    type: "VIDEO",
    instigator: "MANUAL",
})));
export const _PrimaryChannel = Fold.compose(Optics._Col2Video, Optics._Video2PrimaryChannel, Res._Response(), Fold.mapF((x) => ({
    id: x.id,
    type: "CHANNEL",
    instigator: "MANUAL",
})));
export const _Channel = Fold.compose(Optics._Col2Channel, Res._Response(), Fold.mapF((x) => ({
    id: x.id,
    type: "CHANNEL",
    instigator: "MANUAL",
})));

